<template>
  <section class="section">
    <div class="is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <h1 class="title">Recorrência</h1>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <div class="selector">
              <div class="yearSelector">
                <b-field label="Selecione o Ano" label-position="on-border">
                  <b-select v-model="chosenYear" placeholder="Selecione o Ano">
                    <option
                      v-for="option in yearList"
                      :value="option"
                      :key="option"
                    >
                      {{ option }}
                    </option>
                  </b-select>
                </b-field>
              </div>

              <div class="weekSelector">
                <b-field
                  label="Selecione a Semana"
                  label-position="on-border"
                  id="weekSelector"
                >
                  <b-select
                    v-model="chosenWeek"
                    placeholder="Selecione a semana"
                  >
                    <option
                      style="width: 100px"
                      v-for="option in weekList"
                      :value="option"
                      :key="option"
                    >
                      {{ option }}
                    </option>
                  </b-select>
                </b-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="subpage">
      <div class="column is-full is-16-mobile">
        <div class="columns">
          <div class="column is-full is-16-mobile">
            <apex-chart-recurrence
              :data="dataByRecurrence"
              :key="componentReRender"
            ></apex-chart-recurrence>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Webservices from "@/Webservices";
import store from "@/store";
import { mapGetters, mapActions } from "vuex";
import ApexChartRecurrence from "@/components/charts/ApexChartRecurrence";
var moment = require("moment");

const ws = new Webservices();
export default {
  components: {
    ApexChartRecurrence
  },

  data() {
    return {
      yearList: [],
      chosenYear: "",
      weekList: [],
      chosenWeek: "",
      startDate: "",
      endDate: "",
      dataGraph: {
        recurrence: [],
        totalRecurrence: []
      },
      componentReRender: 0
    };
  },

  created() {
    let auxYear = moment().get("year") - 2021;

    for (let aux = 0; aux <= auxYear; aux++) {
      this.yearList[aux] = `Ano de ${moment().get("year") - aux}`;
    }

    var endDate = moment()
      .isoWeekday(1)
      .subtract(1, "days");

    var startDate = moment(endDate)
      .subtract(6, "days")
      .format("DD/MM");

    endDate = moment(endDate).format("DD/MM");
    this.chosenYear = `Ano de ${moment().format("YYYY")}`;
    this.chosenWeek = `${startDate} - ${endDate}`;
  },
  async mounted() {
    await this.selectYear();
    this.selectWeek();
  },
  computed: {
    ...mapGetters([
      "getClientID",
      "getControllerId",
      "getRules",
      "getID",
      "getGroupId",
      "getClients",
      "getToken",
      "getCompanyID"
    ]),
    dataByRecurrence() {
      var output = this.dataGraph;
      return output;
    }
  },
  methods: {
    ...mapActions(["logout"]),
    dateWeekGenerate(year) {
      this.endDate = moment()
        .isoWeek(this.chosenWeek)
        .isoWeekYear(year)
        .isoWeekday(1)
        .toDate();
      this.startDate = moment(this.endDate).subtract(6, "days");
    },
    chosenCurrentWeek() {
      let quantifyWeek = moment(moment()).isoWeek();
      var year = this.chosenYear.replace("Ano de", "");
      var startDate = "";
      var endDate = "";
      for (let aux = 1; aux <= quantifyWeek; aux++) {
        var week = aux.toString();

        startDate = moment()
          .isoWeek(week)
          .isoWeekYear(year)
          .isoWeekday(1);

        endDate = moment(startDate)
          .add(6, "days")
          .format("DD/MM");

        startDate = moment(startDate).format("DD/MM");

        this.weekList[aux - 1] = `${startDate} - ${endDate}`;
      }
    },
    selectYear() {
      this.weekList = [];
      var year = this.chosenYear.replace("Ano de", "");
      var startDate = "";
      var endDate = "";

      if (moment(year).format("yyyy") == moment().format("yyyy")) {
        this.chosenCurrentWeek();
      } else {
        let quantifyWeek = moment(moment(year)).isoWeeksInYear();

        for (let aux = 1; aux <= quantifyWeek; aux++) {
          var week = aux.toString();

          startDate = moment()
            .isoWeek(week)
            .isoWeekYear(year)
            .isoWeekday(1);

          endDate = moment(startDate)
            .add(6, "days")
            .format("DD/MM");

          startDate = moment(startDate).format("DD/MM");

          this.weekList[aux - 1] = `${startDate} - ${endDate}`;
        }
      }
      if (this.chosenWeek) {
        this.dateWeekGenerate(this.chosenYear);
      }
    },

    async selectWeek() {
      if (this.weekList == []) {
        this.chosenCurrentWeek();
      }

      var week = this.weekList.indexOf(this.chosenWeek);

      week = week + 1;

      var year = this.chosenYear.replace("Ano de", "");

      this.startDate = moment()
        .isoWeek(week)
        .isoWeekYear(year)
        .isoWeekday(1)
        .toDate();
      this.endDate = moment(this.startDate).add(6, "days");

      this.startDate = moment(this.startDate)
        .subtract(1, "d")
        .format();
      this.endDate = moment(this.endDate)
        .add(1, "d")
        .format();

      await ws
        .getDataByRecurrence(this.getControllerId, this.startDate, this.endDate)
        .then(response => {
          let count = 1;
          console.log(response.data[0]);

          for (let aux = 0; aux < 7; aux++) {
            let countString = count;
            this.dataGraph.recurrence[aux] =
              countString.toString() + "x na semana";

            this.dataGraph.totalRecurrence[aux] =
              response.data[0].analysedData[count].length;
            count++;
          }
        });
      this.componentReRender++;
    }
  },
  watch: {
    chosenYear() {
      this.selectYear();
    },
    chosenWeek() {
      this.selectWeek();
    },
    getControllerId() {
      if (this.chosenYear) {
        this.selectYear();
      }
      if (this.chosenWeek) {
        this.selectWeek();
      }
    }
  }
};
</script>

<style scoped>
.selector {
  display: flex;
  flex-direction: row;
}
.weekSelector {
  width: 200px;
  padding-left: 20px;
}
.yearSelector {
  width: 150px;
}
.subpage {
  padding-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/Recurrence.vue